<template lang="pug">
.landing-page-wrap
    section#home.home-section.custom-home.home-full-height.bg-dark(:style="getTheImage('home-page-banner-users-collage.png')")
        .hpv-container
            .hp-overlay
        .titan-caption
            .caption-content
                .font-alt.mb-30.titan-title-size-4.main-banner-title-custom {{slogan}}
                .font-alt.mb-50.titan-title-size-2 A social media where you spend time but never waste it
                <router-link to="/signup" class="btn btn-info btn-round color-white btn-info custom">
                  | Sign Up
                </router-link>
                <router-link :to="getPageURL('about')" class="btn btn-border-w btn-round highlighted-button font-bold blue-text m-l-10">
                  | Know More
                </router-link>
    .main
        section.pt-50.custom( :style="getTheImage('main-white-background.png')")
          .container
              h1.font-alt.text-center.font-bold
                | How {{siteName}}
                span.blue-text
                  |  helps you?
              .row.landing-image-text(:class="{'change-direction-row': isMobile()}")
                .col-sm-6.col-sm-push-6
                  h2.font-alt Focus on
                    span.blue-text
                      |  Knowledge sharing
                  p.module-subtitle.font-serif.align-left
                    | {{siteName}} is a short-video based platform where people make and watch knowledgeable content. So you watch short videos that are entertaining but never senseless.
                  <router-link class="btn btn-border-d btn-circle" :to="getPageURL('about')">
                      | Learn More
                  </router-link>
                .col-sm-6.col-sm-pull-6
                  img.center-block.change-pos-on-mobile(:src="getTheImage('app-benefits-watch-videos.png', false)" alt='App Benefits, Watch Videos')
              .row.landing-image-text(:class="{'change-direction-row': isMobile()}")
                .col-sm-6
                  h2.font-alt() Satisfy
                    span.blue-text
                      |  your curiosity
                  p.module-subtitle.font-serif.align-left
                    | On {{siteName}}, people ask questions and others answer them by posting a short "video answer", instead of traditional text answers. See what other people are asking and share your own short "video answers".
                  <router-link class="btn btn-border-d btn-circle" :to="getPageURL('about')">
                    | Learn More
                  </router-link>
                .col-sm-6
                  img.center-block(:class="{'mt-40': isMobile()}" :src="getTheImage('app-benefits-make-money.png', false)" alt="App Benefits, Make Money")
        //<paid-users />
        //<stats-overview />
        //<social-media/>
        section.module.download.pb-0
          .container.text-center
            h2.module-title.font-alt.mb-0 Download
              span.blue-text
                |  the app
            .row.pb-50.download-apps-section-custom
              .col-md-6.col-md-offset-3
                p.module-subtitle.mt-10
                  | {{siteName}} is best when used in the app. Download the app for the best experience.
                a(target="_blank" href="https://play.google.com/store/apps/details?id=com.svanqapp&hl=en_IN")
                  img.image-button.scanner(width="100px" :src="getTheImage('android_scanner.png', false)")
                //a(href='#')
                  img.image-button(src='assets/images/landing/apple-store-icon.png')
                a(target="_blank" href="https://play.google.com/store/apps/details?id=com.svanqapp&hl=en_IN")
                  img.image-button.w-100-px.mb-40(:src="staticImageUrl('play_store.png')")
                //a(href='#')
                  img.image-button(src='assets/images/landing/windows-store-icon.png')
            img(:src="getTheImage('app-download-banner.png', false)" alt="Download the app banner")
        hr.divider-d
</template>
<script>
import mixin from '../../globals/mixin'
import * as constants from '@/constants'
import Preloader from '../../components/preloader'
import auth from '@/auth/helpers'
import StatsOverview from './components/stats-overview'
import SocialMedia from './components/social-media'
import PaidUsers from './components/paid-users'

export default {
  name: 'Landing',
  metaInfo () {
    return {
      title: this.getPageTitle(constants.SITE_SLOGAN)
    }
  },
  components: {
    Preloader,
    StatsOverview,
    SocialMedia,
    PaidUsers
  },
  mixins: [mixin],
  data () {
    return {
      slogan: constants.SITE_SLOGAN
    }
  },
  mounted () {
    this.scrollToTop()
    this.setRefCode()
  },
  methods: {
    setRefCode () {
      let refCode = this.$route.query.refCode || false
      if (refCode) {
        auth.setRefCode(refCode)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/landing/main.vue